import { render, staticRenderFns } from "./LayersSettingsDialog.vue?vue&type=template&id=bc45c7a8"
import script from "./LayersSettingsDialog.vue?vue&type=script&lang=js"
export * from "./LayersSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports